import {gql} from "@apollo/client";

export const GET_USER_FIELDS = gql`
          fragment GetUserFields on User{
                    id,
                    firstName,
                    lastName,
                    userName,
                    status,
                    email,
                    language,
                    wallet {
                      id,
                      currency,
                      balance
                    },
                    prohibitedToPlayByRegulator
                    hasAffiliate
                    isTestUser
          }`;
export const GET_USER_WITHDRAWABLE_BALANCE = gql`
            query GetUserWithdrawableBalance {
                identity {
                    id,
                    wallet{
                      id,
                      balance,
                      currency,
                      withdrawableBalance
                    }
                }
              }
          `;
export const GET_USER = gql`
          ${GET_USER_FIELDS}
          query GetUser {
                identity {
                    ...GetUserFields
                }
              }
          `;

export const GET_USER_WITH_DETAILS = gql`
          ${GET_USER_FIELDS}
          query GetUserWithDetails {
                identity {
                    ...GetUserFields
                    isMale
                    mobileNr
                    birthDate
                    birthPlace
                    address {
                      id
                      street
                      houseNr
                      postBox
                      postalCode
                      city
                      countryCode
                    }
                    details {
                      id
                      identificationNumber
                      nationality
                      identificationCountryOfOrigin
                      identificationExpiryDate
                    }
                    optedInForMarketing
                    hasPassword
                    hideBoostedWin
                }
              }
          `;